import { Location, createLocation } from '../models/location.model';

// New locations based on #sym:createLocation with property names.
export const LOCATIONS = {
  Unknown: createLocation(-2, 'Unknown', 'Unknown', '#000000', false, false, false, false),

  //CROSS
  SwampCross: createLocation(4, 'SwampCross', 'Swamp Cross', '#000000', true, false, false, false),
  ForestCross: createLocation(1006, 'ForestCross', 'Forest Cross', '#000000', true, false, false, false),
  SteppeCross: createLocation(2002, 'SteppeCross', 'Steppe Cross', '#000000', true, false, false, false),
  MountainCross: createLocation(4006, 'MountainCross', 'Mountain Cross', '#000000', true, false, false, false),
  HighlandCross: createLocation(3002, 'HighlandCross', 'Highland Cross', '#000000', true, false, false, false),

  //ROYALS
  Thetford: createLocation(7, 'Thetford', 'Thetford', '#824eb4', true, true, false, false),
  ThetfordCity: createLocation(0, 'ThetfordCity', 'Thetford City', '#824eb4', true, false, true, false),
  // ThetfordPortal: createLocation(301, 'ThetfordPortal', 'Thetford Portal', '#824eb4', true, true, false, false),

  Lymhurst: createLocation(1002, 'Lymhurst', 'Lymhurst', '#338247', true, true, false, false),
  LymhurstCity: createLocation(1000, 'LymhurstCity', 'Lymhurst City', '#338247', true, false, true, false),
  // LymhurstPortal: createLocation(1301, 'LymhurstPortal', 'Lymhurst Portal', '#338247', true, true, false, false),

  Bridgewatch: createLocation(2004, 'Bridgewatch', 'Bridgewatch', '#948a3a', true, true, false, false),
  BridgewatchCity: createLocation(2000, 'BridgewatchCity', 'Bridgewatch City', '#948a3a', true, false, true, false),
  // BridgewatchPortal: createLocation(2301, 'BridgewatchPortal', 'Bridgewatch Portal', '#948a3a', true, true, false, false),

  BlackMarket: createLocation(3003, 'BlackMarket', 'Black Market', '#2e2d2d', true, true, true, false),

  Caerleon: createLocation(3005, 'Caerleon', 'Caerleon', '#d94338', true, true, false, false),
  // Caerleon2: createLocation(3013, 'Caerleon2', 'Caerleon 2', '#d94338', true, false, false, false),

  Martlock: createLocation(3008, 'Martlock', 'Martlock', '#1481ca', true, true, false, false),
  MartlockCity: createLocation(3004, 'MartlockCity', 'Martlock City', '#1481ca', true, false, true, false),
  // MartlockPortal: createLocation(3301, 'MartlockPortal', 'Martlock Portal', '#1481ca', true, true, false, false),

  FortSterling: createLocation(4002, 'FortSterling', 'Fort Sterling', '#969292', true, true, false, false),
  FortSterlingCity: createLocation(4000, 'FortSterlingCity', 'Fort Sterling City', '#969292', true, false, true, false),
  // FortSterlingPortal: createLocation(4301, 'FortSterlingPortal', 'Fort Sterling Portal', '#969292', true, true, false, false),

  Brecilien: createLocation(5003, 'Brecilien', 'Brecilien', '#a26b99', true, true, false, false),
  BrecilienCity: createLocation(5000, 'BrecilienCity', 'Brecilien City', '#a26b99', true, false, true, false),

  // RESTS
  ArthursRestSmugglersNetwork: createLocation(4300, 'ArthursRestSmugglersNetwork', "Arthur's Rest Smugglers Network", '#000000', false, true, false, true),
  MerlynsRestSmugglersNetwork: createLocation(1012, 'MerlynsRestSmugglersNetwork', "Merlyn's Rest Smugglers Network", '#000000', false, true, false, true),
  MorganasRestSmugglersNetwork: createLocation(8, 'MorganasRestSmugglersNetwork', "Morgana's Rest Smugglers Network", '#000000', false, true, false, true),

  // SMUGGLESR
  SunfangRavineSmugglersNetwork: createLocation(2310, 'SunfangRavineSmugglersNetwork', 'Sunfang Ravine Smugglers Network', '#000000', false, true, false, true),
  SpringsumpBasinSmugglersNetwork: createLocation(
    321,
    'SpringsumpBasinSmugglersNetwork',
    'Springsump Basin Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  MeltwaterBogSmugglersNetwork: createLocation(307, 'MeltwaterBogSmugglersNetwork', 'Meltwater Bog Smugglers Network', '#000000', false, true, false, true),
  EverwinterPeakSmugglersNetwork: createLocation(
    4322,
    'EverwinterPeakSmugglersNetwork',
    'Everwinter Peak Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  FarshoreHeathSmugglersNetwork: createLocation(2336, 'FarshoreHeathSmugglersNetwork', 'Farshore Heath Smugglers Network', '#000000', false, true, false, true),
  WillowshadeIcemarshSmugglersNetwork: createLocation(
    320,
    'WillowshadeIcemarshSmugglersNetwork',
    'Willowshade Icemarsh Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  RunnelveinSinkSmugglersNetwork: createLocation(
    341,
    'RunnelveinSinkSmugglersNetwork',
    'Runnelvein Sink Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  WillowshadeHillsSmugglersNetwork: createLocation(
    344,
    'WillowshadeHillsSmugglersNetwork',
    'Willowshade Hills Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  SunkenboughWoodsSmugglersNetwork: createLocation(
    349,
    'SunkenboughWoodsSmugglersNetwork',
    'Sunkenbough Woods Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  ScuttlesinkMarshSmugglersNetwork: createLocation(
    353,
    'ScuttlesinkMarshSmugglersNetwork',
    'Scuttlesink Marsh Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  DeadpineForestSmugglersNetwork: createLocation(
    1312,
    'DeadpineForestSmugglersNetwork',
    'Deadpine Forest Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  WestwealdThicketSmugglersNetwork: createLocation(
    1323,
    'WestwealdThicketSmugglersNetwork',
    'Westweald Thicket Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  TimberslopeGroveSmugglersNetwork: createLocation(
    1339,
    'TimberslopeGroveSmugglersNetwork',
    'Timberslope Grove Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  TimberscarCopseSmugglersNetwork: createLocation(
    1342,
    'TimberscarCopseSmugglersNetwork',
    'Timberscar Copse Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  DeepwoodCopseSmugglersNetwork: createLocation(1343, 'DeepwoodCopseSmugglersNetwork', 'Deepwood Copse Smugglers Network', '#000000', false, true, false, true),
  DriftwoodHollowSmugglersNetwork: createLocation(
    1348,
    'DriftwoodHollowSmugglersNetwork',
    'Driftwood Hollow Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  RivercopseFountSmugglersNetwork: createLocation(
    1359,
    'RivercopseFountSmugglersNetwork',
    'Rivercopse Fount Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  DrybasinRiverbedSmugglersNetwork: createLocation(
    2308,
    'DrybasinRiverbedSmugglersNetwork',
    'Drybasin Riverbed Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  ThirstwaterSteppeSmugglersNetwork: createLocation(
    2311,
    'ThirstwaterSteppeSmugglersNetwork',
    'Thirstwater Steppe Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  BleachskullDesertSmugglersNetwork: createLocation(
    2333,
    'BleachskullDesertSmugglersNetwork',
    'Bleachskull Desert Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  SlakesandsMesaSmugglersNetwork: createLocation(
    2342,
    'SlakesandsMesaSmugglersNetwork',
    'Slakesands Mesa Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  SunfangWastelandSmugglersNetwork: createLocation(
    2344,
    'SunfangWastelandSmugglersNetwork',
    'Sunfang Wasteland Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  DryveinConfluenceSmugglersNetwork: createLocation(
    2347,
    'DryveinConfluenceSmugglersNetwork',
    'Dryvein Confluence Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  SunstrandQuicksandsSmugglersNetwork: createLocation(
    2348,
    'SunstrandQuicksandsSmugglersNetwork',
    'Sunstrand Quicksands Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  MurdergulchCrossSmugglersNetwork: createLocation(
    3306,
    'MurdergulchCrossSmugglersNetwork',
    'Murdergulch Cross Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  RazorrockVergeSmugglersNetwork: createLocation(
    3344,
    'RazorrockVergeSmugglersNetwork',
    'Razorrock Verge Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  RazorrockBankSmugglersNetwork: createLocation(3345, 'RazorrockBankSmugglersNetwork', 'Razorrock Bank Smugglers Network', '#000000', false, true, false, true),
  GravemoundKnollSmugglersNetwork: createLocation(
    3351,
    'GravemoundKnollSmugglersNetwork',
    'Gravemound Knoll Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  MurdergulchRavineSmugglersNetwork: createLocation(
    3355,
    'MurdergulchRavineSmugglersNetwork',
    'Murdergulch Ravine Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  HighstoneLochSmugglersNetwork: createLocation(3357, 'HighstoneLochSmugglersNetwork', 'Highstone Loch Smugglers Network', '#000000', false, true, false, true),
  FloatshoalFloeSmugglersNetwork: createLocation(
    4313,
    'FloatshoalFloeSmugglersNetwork',
    'Floatshoal Floe Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  IceburnFirthSmugglersNetwork: createLocation(4318, 'IceburnFirthSmugglersNetwork', 'Iceburn Firth Smugglers Network', '#000000', false, true, false, true),
  MuntenFellSmugglersNetwork: createLocation(4345, 'MuntenFellSmugglersNetwork', 'Munten Fell Smugglers Network', '#000000', false, true, false, true),
  FrostspringVolcanoSmugglersNetwork: createLocation(
    4351,
    'FrostspringVolcanoSmugglersNetwork',
    'Frostspring Volcano Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
  WhitepeakTundraSmugglersNetwork: createLocation(
    4357,
    'WhitepeakTundraSmugglersNetwork',
    'Whitepeak Tundra Smugglers Network',
    '#000000',
    false,
    true,
    false,
    true
  ),
};

export function getAllRoyalMarketLocations(): Location[] {
  return Object.values(LOCATIONS)
    .filter((x) => x.isRoyal && x.isMarket)
    .sort((a, b) => a.displayName.localeCompare(b.displayName));
}
export function getAllSmugglerMarketLocations(shortenNames: boolean = false): Location[] {
  const result = Object.values(LOCATIONS).filter((x) => x.isSmugglersNetwork && x.isMarket);
  if (shortenNames) {
    result.forEach((x) => (x.displayName = x.displayName.replace(' Smugglers Network', '')));
  }
  return result.sort((a, b) => a.displayName.localeCompare(b.displayName));
}

export function getAllLocations(): Location[] {
  return Object.values(LOCATIONS).sort((a, b) => a.displayName.localeCompare(b.displayName));
}

export function getAllMarketLocations(): Location[] {
  return Object.values(LOCATIONS)
    .filter((x) => x.isMarket)
    .sort((a, b) => a.displayName.localeCompare(b.displayName));
}

export function getAllIslandLocations(): Location[] {
  return Object.values(LOCATIONS)
    .filter((x) => x.isIslandLocation)
    .sort((a, b) => a.displayName.localeCompare(b.displayName));
}

export function getLocationColorByIndex(index: number): string {
  return getAllRoyalMarketLocations().find((x) => x.index === index)?.color ?? 'black';
}

export function getLocation(data: number | string): Location {
  let result: Location = LOCATIONS.Unknown;
  // try to convert to number
  if (!isNaN(+data)) {
    result = getLocationByIndex(+data);
  }
  if (result === LOCATIONS.Unknown && typeof data === 'string') {
    result = getLocationByName(data);
  }
  if (result === LOCATIONS.Unknown) {
    console.warn(`Location ${data} not found, returning ${LOCATIONS.Unknown.displayName}.`);
  }
  return result;
}

function getLocationByIndex(index: number): Location {
  const location = Object.values(LOCATIONS).find((location) => location.index === index);
  if (!location) {
    console.warn(`Location with index ${index} not found, returning ${LOCATIONS.Unknown.displayName}.`);
    return LOCATIONS.Unknown;
  }
  return location;
}

function getLocationByName(name: string): Location {
  const formattedName = name.replace(/\s+/g, '').toLowerCase();
  const location = Object.values(LOCATIONS).find(
    (location) => location.name.replace(/\s+/g, '').toLowerCase() === formattedName || location.displayName.replace(/\s+/g, '').toLowerCase() === formattedName
  );
  if (!location) {
    console.warn(`Location with name ${name} not found, returning ${LOCATIONS.Unknown.displayName}.`);
    return LOCATIONS.Unknown;
  }
  return location;
}
